export function findSubmoduleIdByDescription(subModuleDescription) {
  const modulesString = localStorage.getItem("modules");

  // Validación defensiva: verificar que modules existe en localStorage
  if (!modulesString) {
    return false;
  }

  let modules;
  try {
    modules = JSON.parse(modulesString);
  } catch (error) {
    console.error("Error al parsear modules desde localStorage:", error);
    return false;
  }

  // Validar que modules sea un array válido
  if (!Array.isArray(modules)) {
    return false;
  }

  for (let i = 0; i < modules.length; i++) {
    const subModules = modules[i]?.submodulos;

    // Validar que submodulos sea un array
    if (Array.isArray(subModules)) {
      for (let j = 0; j < subModules.length; j++) {
        if (subModules[j]?.url === subModuleDescription) {
          return true;
        }
      }
    }
  }

  return false;
}
